import ProformaRentalList from "./ProformaRentalList.vue";
import ProformaRentalHistory from "./ProformaRentalHistory.vue";
import ProformaRentalForm from "./ProformaRentalForm.vue";

let routesProformaRental = [
  {
    path: "",
    meta: {
      title: "Chain System",
    },
    name: "ProformaRentalList",
    component: ProformaRentalList,
  },
  {
    path: "history/:customerId",
    meta: {
      title: "Chain System",
    },
    name: "ProformaRentalHistory",
    component: ProformaRentalHistory,
  },
  {
    path: "history/:customerId/edit/:reportId",
    meta: {
      title: "Chain System",
    },
    name: "ProformaRentalEdit",
    component: ProformaRentalForm,
  },
  {
    path: "history/:customerId/view/:reportId",
    meta: {
      title: "Chain System",
    },
    name: "ProformaRentalView",
    component: ProformaRentalForm,
  },
];

export default routesProformaRental;
